import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RepaymentDetailsComponent } from './repayment-details/repayment-details.component';
import { TransactionListComponent } from './transaction-list/transaction-list.component';
import { AuthGuardService } from '@app/extra-module/auth-intercept/auth-guard.service';
import { TransactionDashboardComponent } from './transaction-dashboard/transaction-dashboard.component';
import { AdminHomeComponent } from './admin-home/admin-home.component';
import { MainLayoutComponent } from '@app/shared-module/main-layout/main-layout.component';


const routes: Routes = [
  {
    path: 'admin', component: MainLayoutComponent,
    children: [
      { path: 'manageUser', component: AdminHomeComponent,  data: { title: 'Home' } },
      { path: 'repayment', component: RepaymentDetailsComponent,  data: { title: 'Repayment' } },
      { path: 'transaction', component: TransactionListComponent,  data: { title: 'Transaction' } },
      { path: 'transactionDashboard', component: TransactionDashboardComponent,  data: { title: 'Transaction Dashboard' } },
      // { path: '', redirectTo: 'manageUser', pathMatch: 'full' },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
